// extracted by css-extract-rspack-plugin
export default {"fullWidthLabelEditing":"fullWidthLabelEditing-tCNmJs","inputBox":"inputBox-wxxFQ8"};